import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-4" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "col-6" }
const _hoisted_6 = { class: "row mb-2" }
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = { class: "col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CssDimensionEditor = _resolveComponent("CssDimensionEditor")!
  const _component_MetadataGroupCard = _resolveComponent("MetadataGroupCard")!
  const _component_GenericComponentWrapper = _resolveComponent("GenericComponentWrapper")!

  return (_openBlock(), _createBlock(_component_GenericComponentWrapper, { componentUI: _ctx.componentUI }, {
    default: _withCtx(() => [
      _createVNode(_component_MetadataGroupCard, {
        title: _ctx.$t('cms.rounding'),
        enabled: _ctx.enabled,
        name: _ctx.name,
        errors: _ctx.errors,
        "onUpdate:enabled": _ctx.onEnabledChanged,
        onReset: _ctx.resetToPersisted
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_CssDimensionEditor, {
                    modelValue: _ctx.localDto.top_left,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localDto.top_left) = $event)),
                      _ctx.emitModelChanged
                    ],
                    label: _ctx.$t('cms.topLeft'),
                    name: `${_ctx.name} ${_ctx.$t('cms.topLeft')}`,
                    min: 0,
                    allowDisable: false,
                    fixedUnit: _ctx.CssUnitEnum.PX,
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "label", "name", "fixedUnit", "errors", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_CssDimensionEditor, {
                    modelValue: _ctx.localDto.top_right,
                    "onUpdate:modelValue": [
                      _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localDto.top_right) = $event)),
                      _ctx.emitModelChanged
                    ],
                    label: _ctx.$t('cms.topRight'),
                    name: `${_ctx.name} ${_ctx.$t('cms.topRight')}`,
                    min: 0,
                    allowDisable: false,
                    fixedUnit: _ctx.CssUnitEnum.PX,
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "label", "name", "fixedUnit", "errors", "onUpdate:modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_CssDimensionEditor, {
                    modelValue: _ctx.localDto.bottom_left,
                    "onUpdate:modelValue": [
                      _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localDto.bottom_left) = $event)),
                      _ctx.emitModelChanged
                    ],
                    label: _ctx.$t('cms.bottomLeft'),
                    name: `${_ctx.name} ${_ctx.$t('cms.bottomLeft')}`,
                    min: 0,
                    allowDisable: false,
                    fixedUnit: _ctx.CssUnitEnum.PX,
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "label", "name", "fixedUnit", "errors", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_CssDimensionEditor, {
                    modelValue: _ctx.localDto.bottom_right,
                    "onUpdate:modelValue": [
                      _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localDto.bottom_right) = $event)),
                      _ctx.emitModelChanged
                    ],
                    label: _ctx.$t('cms.bottomRight'),
                    name: `${_ctx.name} ${_ctx.$t('cms.bottomRight')}`,
                    min: 0,
                    allowDisable: false,
                    fixedUnit: _ctx.CssUnitEnum.PX,
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "label", "name", "fixedUnit", "errors", "onUpdate:modelValue"])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["title", "enabled", "name", "errors", "onUpdate:enabled", "onReset"])
    ]),
    _: 1
  }, 8, ["componentUI"]))
}